import React from 'react'
import {
    InvoicesNegotiation,
    MuiBox,
    MuiTooltip,
    MuiTypography,
    formatBRCurrency,
} from '../../../components/storybook'
import { formatDateModal } from '../../Negotiation/functions'
import { numberFormatText } from 'utils/utils'
import { GetThemeColorFromStorage } from '../../../redux/api/themeColor'

const textStyle = {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitLineClamp: 1,
    color: '#636363',
    fontSize: 12,
    textAlign: 'left',
}

export const getTableColumns = ({ redirectToDetailPage, pointsMask }) => [
    {
        id: 'id',
        label: '',
        render: (row) => (
            <MuiTooltip title="Visualizar NF">
                <MuiBox
                    component="span"
                    onClick={() => redirectToDetailPage(row?.invoiceId)}
                    sx={{ cursor: 'pointer' }}
                >
                    <InvoicesNegotiation
                        size={20}
                        color={
                            GetThemeColorFromStorage()?.navigation?.buttons
                                ?.backgroundColor
                        }
                    />
                </MuiBox>
            </MuiTooltip>
        ),
    },
    {
        align: 'left',
        id: 'Centro',
        label: 'Centro',
        render: (row) => {
            const { key, value } = row?.partnerBranchInfo ?? {}
            const text = `${key ?? ''} ${value ?? ''}`.trim()
            return (
                <MuiTooltip title={text || '-'} sx={{ cursor: 'pointer' }}>
                    <MuiTypography variant="body2" sx={textStyle}>
                        {text || '-'}
                    </MuiTypography>
                </MuiTooltip>
            )
        },
    },
    {
        align: 'left',
        id: 'Nº da NF',
        label: 'Nº da NF',
        minWidth: 125,
        render: (row) => (
            <MuiTypography variant="body2" sx={textStyle}>
                {row?.invoiceDocumentID ?? '-'}
            </MuiTypography>
        ),
    },
    {
        align: 'left',
        id: 'Produto/Data da compra',
        label: 'Produto/Data da compra',
        minWidth: 225,
        render: (row) => (
            <MuiTooltip
                title={row?.product?.value ?? '-'}
                sx={{ cursor: 'pointer' }}
            >
                <MuiBox sx={{ width: 200, overflow: 'hidden' }}>
                    <MuiTypography variant="body2" sx={textStyle}>
                        {row?.product?.value ?? '-'}
                    </MuiTypography>
                    <MuiTypography variant="body2" sx={textStyle}>
                        {formatDateModal(row?.date) ?? '-'}
                    </MuiTypography>
                </MuiBox>
            </MuiTooltip>
        ),
    },
    {
        align: 'left',
        id: 'Qtd.',
        label: 'Qtd.',
        render: (row) => (
            <MuiTypography variant="body2" sx={textStyle}>
                {row?.quantity ?? '-'}
            </MuiTypography>
        ),
    },
    {
        align: 'left',
        id: 'Valor da compra',
        label: 'Valor da compra',
        minWidth: 153,
        render: (row) => (
            <MuiTypography variant="body2" sx={textStyle}>
                {formatBRCurrency(row?.totalInvoice) ?? '-'}
            </MuiTypography>
        ),
    },
    {
        align: 'center',
        id: 'Benefício',
        label: 'Benefício',
        minWidth: 100,
        render: (row) => {
            const { typeOfBenefit, total } = row ?? {}
            const isCashback = typeOfBenefit?.value === 'Cashback'
            const value = isCashback
                ? formatBRCurrency(total)
                : numberFormatText(total, `${pointsMask} `, 0)
            return (
                <MuiTypography variant="body2" sx={textStyle}>
                    {value ?? '-'}
                </MuiTypography>
            )
        },
    },
]
